/* eslint-disable jsx-a11y/img-has-alt */
import React, { Component } from 'react';
import { string } from 'prop-types';
import styled from 'styled-components';

const ImageWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: ${props => props.bgsize};
  background-position: ${props => props.bgposition};
  /* background-image: url(${props => props.bg});
  @supports (
    background-image: -webkit-image-set(url(${props => props.obg}) 1x)
  ) {
    background-image: -webkit-image-set(url(${props => props.obg}) 1x);
  } */
`;

const ImageTag = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

class Image extends Component {
  shouldComponentUpdate(nextProps) {
    return this.props.bg !== nextProps.bg;
  }

  render() {
    const { imageClass, bgposition, bgsize, bg, altImage } = this.props;
    // const { show } = this.state;
    // image optimized
    const obg = bg.includes('?') ? `${bg}&fm=webp&lossless=false&q=60` : `${bg}?fm=webp&lossless=false&q=60`;
    const obgMobile = bg.includes('?') ? `${bg}&fm=webp&lossless=true&q=75` : `${bg}?fm=webp&lossless=true&q=75`;

    // return (
    //   <ImageWrapper
    //     bg={bg}
    //     obg={obg}
    //     bgposition={bgposition}
    //     bgsize={bgsize}
    //     className={`${imageClass}`}
    //   />
    // );

    const Picture = ImageTag.withComponent('picture');
    const Source = ImageTag.withComponent('source');

    return (
      <ImageWrapper
        // originalBg={originalUrl}
        bgposition={bgposition}
        bgsize={bgsize}
        className={`${imageClass}`}
      >
        <Picture>
          <Source srcSet={`${obg}, ${obgMobile} 2x`} type="image/webp" />
          <ImageTag alt={altImage} src={bg} />
        </Picture>
      </ImageWrapper>
    );
  }
}

Image.propTypes = {
  bg: string.isRequired,
  bgposition: string,
  bgsize: string,
  imageClass: string,
  altImage: string,
};

Image.defaultProps = {
  bgposition: 'center',
  bgsize: 'cover',
  imageClass: '',
  altImage: '',
};

export default Image;
